import React from 'react';
import { Radio, FormControlLabel, RadioGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CommonButton from '@src/new-components/Button';
import LimitedInput from '@src/new-components/Input/LimitedInput';
import { COLOR } from '@src/styles/color';
import {
  CANCEL_REASONS,
  OTHER_REASON_KEY,
  MAX_TEXT_LENGTH,
} from '../../constants';
import { StyledReasonSelection } from './index.style';

const ReasonSelection = ({
  selectedReason,
  otherReasonText,
  canProceedStep1,
  onSelectReason,
  onOtherTextChange,
  onContinue,
}) => {
  const { t } = useTranslation();
  const isOtherSelected = selectedReason === OTHER_REASON_KEY;

  return (
    <StyledReasonSelection>
      <h2 className="reason-title">{t('cancelReasonTitle')}</h2>
      <p className="reason-description">{t('cancelReasonDescription')}</p>

      <RadioGroup
        className="reasons-grid"
        value={selectedReason}
        onChange={(e) => onSelectReason(e.target.value)}
      >
        {CANCEL_REASONS.map(({ key, labelKey }) => (
          <FormControlLabel
            className={`reason-item${
              selectedReason === key ? ' selected' : ''
            }`}
            value={key}
            control={<Radio disableRipple size="small" />}
            label={t(labelKey)}
            key={key}
          />
        ))}
      </RadioGroup>

      {isOtherSelected && (
        <div className="other-textarea-wrapper">
          <LimitedInput
            placeholder={t('cancelReasonOtherPlaceholder')}
            value={otherReasonText}
            onChange={(e) => onOtherTextChange(e.target.value)}
            maxLength={MAX_TEXT_LENGTH}
            multiline
            rows={3}
            showCounter
          />
        </div>
      )}

      <div className="cta-row">
        <CommonButton
          variant="contained"
          disabled={!canProceedStep1}
          onClick={onContinue}
          customStyle={{
            width: '156px',
            height: '48px',
            background: COLOR.yellow.default,
            borderRadius: '12px',
            fontSize: '16px',
            fontWeight: 600,
            color: COLOR.darkBlue,
            textTransform: 'none',
            whiteSpace: 'nowrap',
            boxShadow: 'none',
            '&:hover': { background: COLOR.yellow.default, boxShadow: 'none' },
          }}
          bgrDisabled={`${COLOR.yellow.default}52`}
        >
          {t('continueButton')}
        </CommonButton>
      </div>
    </StyledReasonSelection>
  );
};

export default ReasonSelection;
